import ModalViewCompany from "./modal-view-company";

export default ModalViewCompany;